/* eslint-disable @typescript-eslint/no-unused-vars */
import { call, takeLatest } from 'redux-saga/effects';
import * as api from '@api/qcTask';
import { toast } from 'react-toastify';
import { actions } from './QCTaskPatient.slice';
import {
  QCTaskPatientChangePatientStatusAction,
  QCTaskPatientFetchAction,
  QCTaskPatientUpdateDobAction,
  QCTaskPatientUpdatePatientCodeAction,
  QCTaskPatientUpdateSiteAction,
} from './QCTaskPatient.types';
import { Resp, dispatch } from '../helpers';
import { QCTaskPatient } from '@dynamika-shared/types/patient';
import { runToast } from '../tools';
import axios from 'axios';

export function* fetchQCTaskPatientWorker(action: QCTaskPatientFetchAction) {
  try {
    const response: Resp<typeof api.fetchQCTaskPatient> = yield call(
      api.fetchQCTaskPatient,
      action.payload.clinicalTrialId,
      action.payload.taskId
    );
    yield dispatch(actions.fetchQCTaskPatientSuccess(response.data));
  } catch (error) {
    yield dispatch(actions.fetchQCTaskPatientFailure(error as Error));
  }
}

export function* changePatientStatusWorker(
  action: QCTaskPatientChangePatientStatusAction
) {
  try {
    yield call(
      api.setQcTaskPatientStatus,
      action.payload.clinicalTrialId,
      action.payload.taskId,
      action.payload.status
    );

    yield call(runToast, 'success', 'Status changed');
    yield dispatch(actions.changePatientStatusSuccess(action.payload.status));
  } catch (error) {
    yield call(
      runToast,
      'error',
      (
        error as {
          response: {
            data: { detail: string };
          };
        }
      )?.response?.data?.detail ?? 'Error during status change'
    );
    yield dispatch(actions.changePatientStatusFailure(error as Error));
  }
}

export function* updatePatientDobWorker(action: QCTaskPatientUpdateDobAction) {
  try {
    const { clinicalTrialId, id, dob } = action.payload;
    yield call(api.updatePatientDob, clinicalTrialId, id, dob);
    yield call(runToast, 'success', 'Date of Birth updated');
    yield dispatch(actions.updatePatientDobSuccess(dob));
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield call(
        runToast,
        'error',
        error.response?.data?.detail ?? 'Error updating Date of Birth'
      );
    } else {
      yield call(runToast, 'error', 'Unexpected error');
    }
    yield dispatch(actions.updatePatientDobFailure(error as Error));
  }
}

export function* updatePatientSiteWorker(
  action: QCTaskPatientUpdateSiteAction
) {
  try {
    const { clinicalTrialId, id, siteId } = action.payload;
    yield call(api.updatePatientSite, clinicalTrialId, id, siteId);
    yield call(runToast, 'success', 'Site updated');
    yield dispatch(actions.updatePatientSiteSuccess(siteId));
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield call(
        runToast,
        'error',
        error.response?.data?.detail ?? 'Error updating Site'
      );
    } else {
      yield call(runToast, 'error', 'Unexpected error');
    }
    yield dispatch(actions.updatePatientSiteFailure(error as Error));
  }
}

export function* updatePatientCodeWorker(
  action: QCTaskPatientUpdatePatientCodeAction
) {
  try {
    const { clinicalTrialId, id, patientCode } = action.payload;
    yield call(api.updatePatientCode, clinicalTrialId, id, patientCode);
    yield call(runToast, 'success', 'Patient code updated');
    yield dispatch(actions.updatePatientCodeSuccess(patientCode));
  } catch (error) {
    if (axios.isAxiosError(error)) {
      yield call(
        runToast,
        'error',
        error.response?.data?.detail ?? 'Error updating patient code'
      );
    } else {
      yield call(runToast, 'error', 'Unexpected error');
    }
    yield dispatch(actions.updatePatientCodeFailure(error as Error));
  }
}

export function* QCTaskPatientSaga() {
  yield takeLatest(actions.fetchQCTaskPatient.type, fetchQCTaskPatientWorker);
  yield takeLatest(actions.changePatientStatus.type, changePatientStatusWorker);
  yield takeLatest(actions.updatePatientDob.type, updatePatientDobWorker);
  yield takeLatest(actions.updatePatientSite.type, updatePatientSiteWorker);
  yield takeLatest(actions.updatePatientCode.type, updatePatientCodeWorker);
}
